import React from 'react';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/layout/Sidebar';
import { PortfolioOverview } from '../components/home/PortfolioOverview';
import { StatsCards } from '../components/home/StatsCards';
import { MarketSnapshot } from '../components/home/MarketSnapshot';
// import { HoldingsTable } from '../components/home/HoldingsTable'
import { ActivityFeed } from '../components/home/ActivityFeed';
export function HomePage() {
  return <div className="flex h-screen bg-background-primary text-text-primary overflow-hidden font-sans" data-id="element-2433">
      <Sidebar data-id="element-2434" />

      <div className="flex-1 flex flex-col min-w-0 mesh-bg" data-id="element-2435">
        <Header data-id="element-2436" />

        <main className="flex-1 overflow-y-auto p-4 md:p-6 space-y-4 md:space-y-6 relative z-0" data-id="element-2437">
          {/* Hero Section */}
          <PortfolioOverview data-id="element-2438" />

          {/* Stats Row */}
          <StatsCards data-id="element-2439" />

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 min-w-0" data-id="element-2440">
            {/* Left Column - Market Snapshot */}
            <MarketSnapshot data-id="element-2441" />

            {/* Right Column - Activity Feed */}
            <ActivityFeed data-id="element-2442" />
          </div>
        </main>
      </div>
    </div>;
}